// eslint-disable-next-line import/no-unresolved
import 'cwj-report-sdk' // 埋点sdk
import { getEnv } from '@/utils/useEnv'
import { BrowserFingerprint } from '@/utils/browserFingerprint'

let chLogObj = null
let vm = null
let isInitialized = false

const fingerprintInstance = new BrowserFingerprint()
// 埋点sdk的值为 daily daily2 gray publish
const getEnvVal = () => {
  const envMap = {
    test: 'daily',
    test2: 'daily2',
    gray: 'gray',
    prod: 'production',
  }
  const env = getEnv()
  return envMap[env]
}

// 可视区域宽度
const cw = function () {
  return parseInt(
    window.innerWidth ||
    document.documentElement.clientWidth ||
    (document.body && document.body.clientWidth) ||
    0,
    10,
  )
}
// 可视区域高度
const ch = function () {
  return parseInt(
    window.innerHeight ||
    document.documentElement.clientHeight ||
    (document.body && document.body.clientHeight) ||
    0,
    10,
  )
}

/**
* 下面方法是获取公共参数，sdk自动获取上报的参数如下：
* sdk自动获取上报参数：
* ua(ua) userAgent
* sr(screenResolution) 屏幕分辨率
* id 事件唯一id
* rurl(realUrl) 页面完整地址
* st(start) 页面进入到触发时的时长
* tid(tid) 会话ID，一个完整会话内保持不变
* tm(time) 埋点上报时的时间戳
*/
const getPublicParams = () => {
  if (!vm || !vm.$store) {
    console.warn('TrackReport: Vue instance or store not available')
    return {}
  }

  const { userInfo } = vm.$store.getters
  const route = vm.$route
  return {
    version: window.__APP_VERSION_INFO__?.version || '', // 版本号
    uid: userInfo?.id || '', // 用户id
    tenantId: userInfo?.tenantId || '', // 服务商id
    pageId: route?.name || '', // 资源key
    domain: location.host,
    pathname: location.pathname,
    pathSearch: location.search,
    channel: 'che',
    windowSize: `${cw()}x${ch()}`,
    scrollX: window.scrollX,
    scrollY: window.scrollY,
    diu: fingerprintInstance.getDeviceId(), // 设备ID
    sonChannel: 'web', // 子渠道
  }
}

// TrackReport 对象
const trackReportObject = {
  // 初始化方法 - 需要传入 vueInstance
  init(options = {}) {
    if (isInitialized) {
      console.warn('TrackReport: Already initialized')
      return
    }

    const {
      vueInstance,
      enableFingerprint = true, // 默认启用指纹生成
      ...config
    } = options

    // 设置 Vue 实例
    if (vueInstance) {
      vm = vueInstance
    } else {
      console.error('TrackReport: vueInstance is required for initialization')
      return
    }
    // sdk获取上报域名时没有使用初始化参数__env__，而是使用window.__env__，所以这里先赋值
    window.__env__ = getEnvVal()
    // 初始化 CHLog SDK
    try {
      chLogObj = new window.CHLog({
        isPerformance: false,
        __env__: getEnvVal(),
        ...config,
      })
      isInitialized = true
      console.log('TrackReport: Initialized successfully')
    } catch (error) {
      console.error('TrackReport: Failed to initialize CHLog', error)
    }
  },

  // 事件上报
  trackReport(eventId, data, eventType = 'click', immediately = false) {
    if (!isInitialized || !chLogObj) {
      console.warn('TrackReport: Not initialized')
      return
    }

    const params = {
      ...getPublicParams(),
      type: eventType,
      ...data,
    }
    chLogObj.send(params.pageId, eventId, params, immediately)
  },

  // 点击事件上报
  trackClick(eventId, data, immediately = false) {
    if (!isInitialized || !chLogObj) {
      console.warn('TrackReport: Not initialized')
      return
    }

    const params = {
      ...getPublicParams(),
      type: 'click',
      ...data,
    }
    chLogObj.send(params.pageId, eventId, params, immediately)
  },

  // 曝光事件上报
  trackExposure(eventId, data, immediately = false) {
    if (!isInitialized || !chLogObj) {
      console.warn('TrackReport: Not initialized')
      return
    }

    const params = {
      ...getPublicParams(),
      ...data,
    }
    chLogObj.send(params.pageId, eventId, params, immediately)
  },
  // 页面进入时事件上报
  trackPageEnter(eventId, data, immediately = false) {
    if (!isInitialized || !chLogObj) {
      console.warn('TrackReport: Not initialized')
      return
    }

    const params = {
      ...getPublicParams(),
      ...data,
    }
    chLogObj.send(params.pageId, eventId, params, immediately)
  },
  // 页面离开时事件上报
  trackPageLeave(eventId, data, immediately = false) {
    if (!isInitialized || !chLogObj) {
      console.warn('TrackReport: Not initialized')
      return
    }

    const params = {
      ...getPublicParams(),
      ...data,
    }
    chLogObj.send(params.pageId, eventId, params, immediately)
  },

  // 检查是否已初始化
  isReady() {
    return isInitialized
  },
}

// 导出默认对象
export default trackReportObject

// 同时导出各个方法以便按需导入
export const {
  init,
  trackReport,
  trackClick,
  trackExposure,
  trackPageEnter,
  trackPageLeave,
  isReady,
} = trackReportObject
